export enum MfaMethods {
  NOMFA = 'NOMFA',
  TOTP = 'TOTP',
  SOFTWARE_TOKEN_MFA = 'SOFTWARE_TOKEN_MFA',
  SMS = 'SMS',
  SMS_MFA = 'SMS_MFA',
}
